import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function reportModel() {
  const fetchReportListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/report/list",
    method: "POST",
    payload: {
      limit: 9999,
      page: 1,
      Filters: [],
    },
  });

  const fetchFileListModel = reactive({
    api: apiEndpoint.bcrm_platform + "/report/filelist",
    method: "POST",
    payload: {
      limit: 10,
      page: 1,
      Filters: [],
    },
  });

  const generateReportModel = reactive({
    api: apiEndpoint.bcrm_platform + "/report/generate",
    method: "POST",
    payload: {
      Report_Id: null,
      Report_Key: null,
      Filters: {
        StartDate: null,
        EndDate: null,
      },
    },
  });

  const removeReportModel = reactive({
    api: apiEndpoint.bcrm_platform + "/report/remove",
    method: "POST",
    payload: { Report_Job_Id: null, Report_Id: null },
  });

  return {
    fetchReportListModel,
    fetchFileListModel,
    generateReportModel,
    removeReportModel,
  };
}
